import React, { useEffect, useState } from 'react'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http';
import styles from './BDT_Bus.module.css'


function LeftCardContainer(props) {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const { title, apiEnd, filterdata } = props
    const [value, setValue] = useState('')

    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
                body: { filterdata },
            },
            (data) => {
                // if (title == "Lowest cell RUL") {
                if (title == "Lowest RUL") {
                    setValue(data?.min_Pack_RUL.value)
                }
                // if (title == "Lowest cell SoH") {
                if (title == "Lowest SoH") {
                    setValue(data?.min_min_soh_min.value)
                }
                if (title == "Highest cell IR") {
                    setValue(data?.max_Max_IR_Ohmic_Max.value)
                }
            }
        );
    }, [apiEnd, filterdata]);



    return (
        <>
            <div className={`col-lg-12 col-md-3 rounded-3 py-1 mb-2 d-flex align-items-center ${styles.bg_light_blue}`}>
                <div className={`${styles.widgetIcon} my-2`}>
                    {
                        title == "Lowest RUL" ? <img src={"/assets/img_Bus/BDT/rul_cycle_img.png"} alt='rul_cycle_img.png' />
                            : title == "Lowest SoH" ? <img src={"/assets/img_Bus/BDT/soh_cell_img.png"} alt='rul_cycle_img.png' />
                                : title == "Highest cell IR" ? <img src={"/assets/img_Bus/BDT/highest_cell_IR.png"} alt='rul_cycle_img.png' />
                                    : <></>
                    }
                </div>
                <div className="my-4 ms-4">
                    <p className={`h4 pb-1 ${styles.bold_text}`}>{title}</p>
                    {
                        title == "Lowest RUL" ? <p className={`mb-1 ${styles.bolder_text}`}>{value} cycles</p>
                            : title == "Lowest SoH" ? <p className={`mb-1 ${styles.bolder_text}`}>{value ? Math.floor(value) + "%" : ""}</p>
                                : title == "Highest cell IR" ? <p className={`mb-1 ${styles.bolder_text}`}>{value ? <>{Number(value?.toFixed(2)) + " "}<span>m'&#8486;</span></> : ""}</p>
                                    : <></>
                    }
                </div>
            </div>
        </>
    )
}

export default LeftCardContainer
